import { render, staticRenderFns } from "./Audio_edit.vue?vue&type=template&id=41bb924f&style=true"
import script from "./Audio_edit.vue?vue&type=script&lang=js"
export * from "./Audio_edit.vue?vue&type=script&lang=js"
import style0 from "./Audio_edit.vue?vue&type=style&index=0&id=41bb924f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports